export default "<!-- <p>authorize-user works!</p> -->\r\n\r\n<app-select-projectticket></app-select-projectticket>";